import * as Sentry from "@sentry/react";
import "../global-config";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Router, browserHistory, PlainRoute, RouterState, RedirectFunction } from "react-router";
import { Helmet } from "react-helmet";
import { DEFAULT_TITLE } from "@lib/constants/ui";
import i18n from "../lib/i18n/i18n";
import { I18nextProvider } from "react-i18next";
import { KeyboardEventManager, RefocusManager, Outliner } from "@root/shared";
import { NewApp } from "./new-app";
import { GitHubAppShell } from "./github-app-shell";
import { RepositoryList } from "./repository-list";
import { GitHubLoginShell } from "./github-login-shell";
import { telemetry } from "../lib/telemetry";
import { appStore } from "../stores/app-store";
import { BillingPlanErrorDialog } from "./error-dialogs";
import { userStore } from "@root/stores";

telemetry.setAppStoreContext(appStore);

const onRouteUpdate = (nextState: RouterState) => {
  telemetry.setPathContext(nextState.location.pathname);
};

const routes: PlainRoute[] = [
  {
    path: "github-app/create-account",
    component: GitHubLoginShell,
    // @ts-ignore. [Should fix it in the future] Strict error.
    onEnter: (nextState: RouterState, replace: RedirectFunction, cb: Function) => {
      onRouteUpdate(nextState);
      cb();
    },
  },
  {
    path: "github-app/setup/repositories",
    component: GitHubAppShell,
    indexRoute: {
      component: RepositoryList,
    },
    childRoutes: [
      {
        path: ":repoId",
        component: NewApp,
      },
    ],
    // @ts-ignore. [Should fix it in the future] Strict error.
    onEnter: (nextState: RouterState, replace: RedirectFunction, cb: Function) => {
      telemetry.setUser(userStore.currentUser);

      onRouteUpdate(nextState);
      cb();
    },
    // @ts-ignore. [Should fix it in the future] Strict error.
    onChange: (prevState: RouterState, nextState: RouterState, replace: RedirectFunction, cb: Function) => {
      onRouteUpdate(nextState);
      cb();
    },
  },
  {
    path: "github-app/oauth-error",
    component: GitHubAppShell,
    indexRoute: {
      component: BillingPlanErrorDialog,
    },
    // @ts-ignore. [Should fix it in the future] Strict error.
    onEnter: (nextState: RouterState, replace: RedirectFunction, cb: Function) => {
      onRouteUpdate(nextState);
      cb();
    },
  },
];

// The primary client-side router.
ReactDOM.render(
  <Sentry.ErrorBoundary>
    <Helmet defaultTitle={DEFAULT_TITLE} titleTemplate="%s · App Center" />
    <React.Suspense fallback={null}>
      <I18nextProvider i18n={i18n}>
        <KeyboardEventManager>
          <RefocusManager>
            <Outliner>
              <Router history={browserHistory} routes={routes} />
            </Outliner>
          </RefocusManager>
        </KeyboardEventManager>
      </I18nextProvider>
    </React.Suspense>
  </Sentry.ErrorBoundary>,
  document.getElementById("app")
);
